export default {
  label: 'Publicações checadas',
  placeholder: 'Todas',
  items: {
    all: 'Todas',
    onlyChecked: 'Somente Checadas',
    onlyUnchecked: 'Somente Não-checadas',
  },
};
